import { render, staticRenderFns } from "./VDialogAccountPass.vue?vue&type=template&id=845c76be"
import script from "./VDialogAccountPass.vue?vue&type=script&lang=js"
export * from "./VDialogAccountPass.vue?vue&type=script&lang=js"
import style0 from "./VDialogAccountPass.vue?vue&type=style&index=0&id=845c76be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports